import { z } from "zod";
import { useNavigate } from "react-router-dom";
import TempalateForm from "../Register/TemplateForm";
import { loginApi } from "./api";
import DynamicForm from "../../components/DynamicForm";

const FormLogin = () => {
  const navigate = useNavigate();

  // Definisi schema Zod secara dinamis untuk login
  const schema = z.object({
    username: z.string().min(1, { message: "Username wajib diisi" }),
    password: z.string().min(1, { message: "Password wajib diisi" }),
  });

  // Definisi field untuk form login
  const fields = [
    {
      name: "username",
      placeholder: "Username",
    },
    {
      name: "password",
      type: "password",
      placeholder: "Password",
    },
  ];

  const onSubmit = async (data) => {
    try {
      const res = await loginApi(data);
      if (res.status === 200) {
        sessionStorage.setItem("token_login", res.data.access_token);
        navigate(`/admin/products/${res.data.access_token}`);
      }
    } catch (error) {}
  };

  return (
    <TempalateForm>
      <h1 className="form-title">Login Admin</h1>
      {/* Gunakan DynamicForm di sini dengan schema yang dinamis */}
      <DynamicForm schema={schema} fields={fields} onSubmit={onSubmit} />
    </TempalateForm>
  );
};

export default FormLogin;
